// Aircraft imagery: each photo is the EXACT aircraft type named, sourced from
// Wikimedia Commons files whose titles identify the specific type. Do not
// substitute a different aircraft image on any profile.

const W = {
  phenom300:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Hannover_Airport_NetJets_Europe_Embraer_Phenom_300_CS-PHL_%28DSC4826%29.jpg/1920px-Hannover_Airport_NetJets_Europe_Embraer_Phenom_300_CS-PHL_%28DSC4826%29.jpg",
  cj3: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Cessna_CitationJet_CJ3_N1H_FDK_MD2.jpg/1920px-Cessna_CitationJet_CJ3_N1H_FDK_MD2.jpg",
  xls: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Cessna_Citation_XLS_N613WM_FDK_MD1.jpg/1920px-Cessna_Citation_XLS_N613WM_FDK_MD1.jpg",
  learjet60:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Learjet_60_N74HT_FDK_MD1.jpg/1920px-Learjet_60_N74HT_FDK_MD1.jpg",
  challenger350:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Netjets_Bombardier_Challenger_350_N757QS_BWI_MD1.jpg/1920px-Netjets_Bombardier_Challenger_350_N757QS_BWI_MD1.jpg",
  latitude:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Cessna_Citation_Latitude_N571QS_FDK_MD1.jpg/1920px-Cessna_Citation_Latitude_N571QS_FDK_MD1.jpg",
  global6000:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/VistaJet_Bombardier_Global_6000%2C_Le_Grand-Saconnex_%28BL7C0566%29.jpg/1920px-VistaJet_Bombardier_Global_6000%2C_Le_Grand-Saconnex_%28BL7C0566%29.jpg",
  g550: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Gulfstream_G550%2C_EBACE_2018%2C_Le_Grand-Saconnex_%28BL7C0707%29.jpg/1920px-Gulfstream_G550%2C_EBACE_2018%2C_Le_Grand-Saconnex_%28BL7C0707%29.jpg",
  falcon7x:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Dassault_Falcon_7X_N73KT_FDK_MD1.jpg/1920px-Dassault_Falcon_7X_N73KT_FDK_MD1.jpg",
  kingair350:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Beechcraft_King_Air_350_N614CW_FDK_MD1.jpg/1920px-Beechcraft_King_Air_350_N614CW_FDK_MD1.jpg",
  pc12: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Pilatus_PC-12_in_Okavango_Delta.jpg/1920px-Pilatus_PC-12_in_Okavango_Delta.jpg",
  aw109: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/S2-AJP_-_AgustaWestland_AW109SP_GrandNew_-_Serial_22395_-_VGHS.jpg/1920px-S2-AJP_-_AgustaWestland_AW109SP_GrandNew_-_Serial_22395_-_VGHS.jpg",
  h125: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Airbus_H125%2C_AERO_2018%2C_Friedrichshafen_%281X7A4715%29.jpg/1920px-Airbus_H125%2C_AERO_2018%2C_Friedrichshafen_%281X7A4715%29.jpg",
};

export const AIRCRAFT_CATEGORIES = [
  "Light Jets",
  "Midsize Jets",
  "Super Midsize Jets",
  "Heavy Jets",
  "Turboprops",
  "Helicopters",
];

export const AIRCRAFT = [
  {
    name: "Embraer Phenom 300",
    category: "Light Jets",
    passengers: "6–7",
    range: "approx. 2,000 nm",
    baggage: "Generous hold for a light jet",
    cabin: "A quiet, modern cabin with club seating, large windows and a private lavatory — well suited to regional sectors of two to three hours.",
    image: W.phenom300,
  },
  {
    name: "Cessna Citation CJ3+",
    category: "Light Jets",
    passengers: "6–7",
    range: "approx. 2,040 nm",
    baggage: "External baggage compartment",
    cabin: "Efficient and comfortable for short-hop business travel, with a bright cabin and reclining leather seats.",
    image: W.cj3,
  },
  {
    name: "Cessna Citation XLS+",
    category: "Midsize Jets",
    passengers: "7–8",
    range: "approx. 2,100 nm",
    baggage: "Large external hold",
    cabin: "A stand-up feel midsize cabin with a refreshment centre — a workhorse for regional business routes.",
    image: W.xls,
  },
  {
    name: "Learjet 60XR",
    category: "Midsize Jets",
    passengers: "6–7",
    range: "approx. 2,400 nm",
    baggage: "Aft baggage compartment",
    cabin: "Fast-climbing midsize jet with a comfortable double-club cabin for time-critical regional trips.",
    image: W.learjet60,
  },
  {
    name: "Bombardier Challenger 350",
    category: "Super Midsize Jets",
    passengers: "8–9",
    range: "approx. 3,200 nm",
    baggage: "Large accessible hold",
    cabin: "A wide, flat-floor cabin with low noise levels and a full galley — comfortable for sectors of five to seven hours.",
    image: W.challenger350,
  },
  {
    name: "Cessna Citation Latitude",
    category: "Super Midsize Jets",
    passengers: "8",
    range: "approx. 2,700 nm",
    baggage: "Generous external hold",
    cabin: "A spacious stand-up cabin with wide seats and large windows, bridging regional and continental missions.",
    image: W.latitude,
  },
  {
    name: "Bombardier Global 6000",
    category: "Heavy Jets",
    passengers: "12–14",
    range: "approx. 6,000 nm",
    baggage: "Walk-in baggage hold",
    cabin: "A true intercontinental cabin with distinct zones for work, dining and rest, plus a full galley and crew rest on longer sectors.",
    image: W.global6000,
  },
  {
    name: "Gulfstream G550",
    category: "Heavy Jets",
    passengers: "12–16",
    range: "approx. 6,750 nm",
    baggage: "Walk-in baggage hold",
    cabin: "Long-range flagship cabin with signature oval windows, multiple living areas and sleeping arrangements for overnight sectors.",
    image: W.g550,
  },
  {
    name: "Dassault Falcon 7X",
    category: "Heavy Jets",
    passengers: "12–14",
    range: "approx. 5,950 nm",
    baggage: "Large internal hold",
    cabin: "A refined three-engine long-range jet with a whisper-quiet cabin and excellent short-field performance.",
    image: W.falcon7x,
  },
  {
    name: "Beechcraft King Air 350i",
    category: "Turboprops",
    passengers: "up to 8",
    range: "approx. 1,800 nm",
    baggage: "Internal baggage area",
    cabin: "A pressurised, comfortable cabin able to use short regional runways that jets cannot — ideal for remote airstrips.",
    image: W.kingair350,
  },
  {
    name: "Pilatus PC-12",
    category: "Turboprops",
    passengers: "6–8",
    range: "approx. 1,800 nm",
    baggage: "Large aft cargo door",
    cabin: "A versatile single-engine turboprop with executive interiors and exceptional access to short, unpaved strips.",
    image: W.pc12,
  },
  {
    name: "Leonardo AW109",
    category: "Helicopters",
    passengers: "5–6",
    range: "approx. 500 nm",
    baggage: "Cabin baggage only",
    cabin: "A fast twin-engine helicopter for city transfers, airport connections and point-to-point travel where runways are irrelevant.",
    image: W.aw109,
  },
  {
    name: "Airbus H125",
    category: "Helicopters",
    passengers: "4–5",
    range: "approx. 340 nm",
    baggage: "Cabin baggage only",
    cabin: "A light, agile single-engine helicopter for short transfers, resort access and aerial work in confined areas.",
    image: W.h125,
  },
];
